import {
  CheckIcon,
  EyeIcon,
  LoaderIcon,
  type LucideIcon,
  MinusIcon,
  PackageCheck,
  PackageIcon,
  SendIcon,
  XIcon,
} from 'lucide-react';
import {
  HighPriorityIcon,
  LowPriorityIcon,
  MediumPriorityIcon,
} from '../-components/priority-icons';

export type StatusType = {
  status: string;
  label: string;
  Icon: LucideIcon;
  iconClassName: string;
  iconClassNameInverted: string;
};

export const STATUSES: Record<string, StatusType> = {
  pending: {
    status: 'pending',
    label: 'Submitted',
    Icon: SendIcon,
    iconClassName: 'stroke-indigo-950 dark:stroke-indigo-100',
    iconClassNameInverted: 'dark:stroke-indigo-950 stroke-indigo-100',
  },
  inReview: {
    status: 'in-review',
    label: 'In Review',
    Icon: EyeIcon,
    iconClassName: 'stroke-indigo-950 dark:stroke-indigo-100',
    iconClassNameInverted: 'dark:stroke-indigo-950 stroke-indigo-100',
  },
  rejected: {
    status: 'rejected',
    label: 'Rejected',
    Icon: XIcon,
    iconClassName: 'stroke-rose-500',
    iconClassNameInverted: 'stroke-rose-500',
  },
  approved: {
    status: 'approved',
    label: 'Approved',
    Icon: CheckIcon,
    iconClassName: 'stroke-green-700 dark:stroke-green-500',
    iconClassNameInverted: 'dark:stroke-green-700 stroke-green-500',
  },
  inProgress: {
    status: 'in-progress',
    label: 'In Progress',
    Icon: LoaderIcon,
    iconClassName: 'stroke-blue-700 dark:stroke-blue-400',
    iconClassNameInverted: 'dark:stroke-blue-700 stroke-blue-400',
  },
  done: {
    status: 'done',
    label: 'Done',
    Icon: PackageCheck,
    iconClassName: 'stroke-orange-700 dark:stroke-orange-300',
    iconClassNameInverted: 'dark:stroke-orange-700 stroke-orange-300',
  },
};

export type PriorityType = {
  status: string;
  label: string;
  Icon: LucideIcon;
};

export const PRIORITIES: Record<string, PriorityType> = {
  no: {
    status: 'no',
    label: 'No priority',
    Icon: MinusIcon as LucideIcon,
  },
  low: {
    status: 'low',
    label: 'Low',
    Icon: LowPriorityIcon as LucideIcon,
  },
  medium: {
    status: 'medium',
    label: 'Medium',
    Icon: MediumPriorityIcon as LucideIcon,
  },
  high: {
    status: 'high',
    label: 'High',
    Icon: HighPriorityIcon as LucideIcon,
  },
};

export const ALL_STATUSES_OPTION = {
  status: 'all',
  label: 'All Requests',
  Icon: PackageIcon,
  iconClassName: 'text-muted-foreground',
};
